export default {"src":"/_next/static/media/0xb05097849BCA421A3f51B249BA6CCa4aF4b97cb9.46ec0191.svg","height":115,"width":115,"blurWidth":0,"blurHeight":0};